import CardTile from '@/components/cards/CardTile'
import EmptyState from '@/components/ui/EmptyState'
import { useAllCards } from '@/hooks/useCards'
import { useAllProfiles } from '@/hooks/useProfile'
import { slugifyStoreName } from '@/lib/storeSlug'
import {Radio} from 'lucide-react'
import { useState } from 'react'

const FILTERS = [
  { value: 'All', label: 'All listings' },
  { value: 'card', label: 'Singles' },
  { value: 'sealed', label: 'Sealed' },
]

function Feed() {
  const [listingFilter, setListingFilter] = useState('All')
  const { cards, loading } = useAllCards(listingFilter)
  const { byUserId } = useAllProfiles()

  return (
    <div className="mx-auto max-w-6xl px-4 pb-14 pt-6 sm:px-6 sm:pt-8">
      <div className="mb-6">
        <div className="mb-3 inline-flex items-center gap-2 rounded-full border-2 border-[#FF1A1A] bg-[#FF1A1A] px-3 py-1 text-xs font-extrabold uppercase tracking-wide text-white shadow-[0_3px_0_#9d1010]">
          <Radio className="h-3.5 w-3.5" />
          Live Pokemon feed
        </div>
        <h1 className="font-display text-3xl font-extrabold text-white sm:text-5xl">Fresh pulls and sealed drops</h1>
        <p className="mt-2 max-w-xl text-sm font-semibold text-white/55">
          Browse singles and sealed product from Pokemon collectors. Filter by what you want to shop.
        </p>
      </div>

      <div className="mb-6 flex flex-wrap gap-2">
        {FILTERS.map(filter => {
          const active = listingFilter === filter.value
          return (
            <button
              key={filter.value}
              type="button"
              onClick={() => setListingFilter(filter.value)}
              className={`rounded-full border-2 px-3.5 py-1.5 text-xs font-extrabold uppercase tracking-wide transition-transform hover:-translate-y-0.5 ${
                active
                  ? 'border-[#FFDE00] bg-[#FFDE00] text-black shadow-[0_3px_0_#c9a800]'
                  : 'border-white/15 bg-white/5 text-white/70'
              }`}
            >
              {filter.label}
            </button>
          )
        })}
      </div>

      {loading ? (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {Array.from({ length: 8 }).map((_, i) => (
            <div key={i} className="aspect-[3/4] animate-pulse rounded-2xl bg-white/5" />
          ))}
        </div>
      ) : cards.length === 0 ? (
        <EmptyState
          title={listingFilter === 'sealed' ? 'No sealed product yet' : listingFilter === 'card' ? 'No singles yet' : 'No listings yet'}
          description="Be the first to post a Pokemon card or sealed product to the feed."
        />
      ) : (
        <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-4">
          {cards.map(card => {
            const profile = byUserId.get(card.userId)
            return (
              <CardTile
                key={card._id}
                card={card}
                storeName={profile?.storeName}
                storeSlug={profile?.storeSlug || slugifyStoreName(profile?.storeName)}
                storeUserId={card.userId}
              />
            )
          })}
        </div>
      )}
    </div>
  )
}

export default Feed
